<template>
  <svg
    v-if="$options.svgSprite"
    style="display: none;"
    width="0" height="0"
    v-html="$options.svgSprite"
  >
  </svg>
</template>

<script>
function getSymbols(svgContext) {
  return svgContext.keys().map((path) => {
    const content = svgContext(path);
    const id = path.replace(/^\.\/(.*)\.\w+$/, '$1');
    return content.replace('<svg', `<symbol id="icon-${id}"`).replace('svg>', 'symbol>');
  });
}

export default {
  name: 'Icons',
  props: {
    iconsContext: Function,
  },
  svgSprite: null,
  created() {
    // Design system icons
    const icons = getSymbols(require.context(
      '!svg-inline-loader?'
      + 'removeTags=true&removeSVGTagAttrs=true&removingTagAttrs=fill'
      + '!./icons',
      false,
      /\w+\.svg$/i,
    ));

    // Local project icons
    if (this.iconsContext) {
      icons.push(...getSymbols(this.iconsContext));
    }

    this.$options.svgSprite = icons.join('\n');
  },
};
</script>
